// 子账号

import { HttpSubAccountList,HttpSubAccountDel } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
import compUpdate from './update'
import { mapGetters } from 'vuex';
import mixin from '../mixin'
export default {
    mixins: [TableList,mixin],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpSubAccountList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'add':
                    this.operate = {
                        title: '新增',
                        show: true,
                        width:700,
                        component: "compUpdate",
                        showFooter: false,
                        querytype: "add",
                        alertbox:'alertbox'
                    }
                    break;
                case 'query':
                    this.operate = {
                        title: '查看',
                        show: true,
                        width:700,
                        component: "compUpdate",
                        showFooter: false,
                        querytype:'query',
                        activeid:params,
                    }
                    break;

                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.edit', { defaultValue: "编辑" }),
                        show: true,
                        width:700,
                        component: "compUpdate",
                        showFooter: false,
                        querytype:'edit',
                        activeid:params,
                        alertbox:'alertbox'
                    }
                    break;
                case 'del':
                    // console.log(type);
                    this.operate = {
                        show: true,
                        alert: 'error',
                        params: { id: params },
                        title: '删除子账号',
                        ajaxRequest: HttpSubAccountDel,
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, status } = row;
            return [
            //     {
            //     label: '查看',
            //     show: true,
            //     params: id,
            //     operate: 'query'
            // },
                {
                label: this.$t('global.common.edit', { defaultValue: "编辑" }),
                show: true,
                params: id,
                operate: 'edit'
            },
                {
                    label: this.$t('global.common.delete', { defaultValue: "删除" }),
                    show: true,
                    params: id,
                    operate: 'del'
                },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.bill.sub_account_name', { defaultValue: "账号" }),
                    key: 'EQ_account',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    show: true,
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    style: "width:200px",
                    key: 'GE_createdAt',
                    props: {
                        format: 'yy-mm-dd',
                        confirm: false,
                    },
                    show:true,
                },
                {
                    label: "-",
                    tag: 'vDatepicker',
                    style: "width:200px",
                    key: 'LE_createdAt',
                    props: {
                        format: 'yy-mm-dd',
                        confirm: false,
                    },
                    show:true,
                },
                {
                    label:this.$t('',{defaultValue:'计费类型'}),
                    tag:'vSelect',
                    key:'EQ_billingType',
                    show:false,
                    required:true,
                    options:[
                        {value:'',label:'全部'},
                        {value:0,label:'整体加点'},
                        {value:1,label:'系统报价'}
                    ]
                },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    maxWidth: 80,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.bill.sub_account_name', { defaultValue: "账号" }),
                    key: 'account',
                },
                {
                    title: this.$t('global.common.organization', { defaultValue: "组织" }),
                    key: 'orgName',
                },
                {
                    title:'计费类型',
                    key:'billingType',
                    render:(h,{row})=>{
                        return row.billingType===0?'系统报价':row.billingType===1?'整体加点':'--'
                    }
                },
                {
                    title:'加点费率',
                    key:'coefficient',
                    render:(h,{row})=>{
                        return row.billingType===1?row.coefficient:'--'
                    }
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                },

            ];
        },
    },
};




